import {ref} from 'vue';
import {trackCubeCustomEvent} from '../tracking/trackingLayer';

const templateElement = document.getElementById('additional-price-info-template');
export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    displayPrice: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const pangvModal = ref(null);

    const openLayer = () => {
      pangvModal.value.addEventListener('ents-modal:close', onLayerClose);
      pangvModal.value.classList.remove('hidden');
      pangvModal.value.show();
      trackModalEvent('open');
    };

    const onLayerClose = () => {
      trackModalEvent('close');
      pangvModal.value.removeEventListener('ents-modal:close', onLayerClose);
    };

    const trackModalEvent = (action) => {
      trackCubeCustomEvent(`pangv_layer_${action}`, {
        event_category: 'pangv_layer',
        is_interaction_event: true,
        event_type: 'click',
      });
    };

    return {
      openLayer, pangvModal,
    };
  },
};
